exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full[data-v-468f6b3c]{width:100%;height:100%}", ""]);

// exports
